// 银行 logo（图标）统一放在 assets/v2/yh 下
import gsyhIcon from "../assets/v2/yh/Frame.png";
import nyyhIcon from "../assets/v2/yh/Agriculturalbank.png";
import xyyhIcon from "../assets/v2/yh/IndustrialBank.png";
import gdyhIcon from "../assets/v2/yh/ChinaEverbrightBank.png";
import shyhIcon from "../assets/v2/yh/SPDbank.png";
import jtyhIcon from "../assets/v2/yh/BankofCommunications.png";
import zsyhIcon from "../assets/v2/yh/ChinaMerchantsBank.png";
import yzyhIcon from "../assets/v2/yh/PSBC.png";
import gfpayhIcon from "../assets/v2/yh/PingAnBank.png";
import gpzgyhIcon from "../assets/v2/yh/Bankofchina.png";
import gpjsyhIcon from "../assets/v2/yh/Chinaconstructionbank.png";
import gpmsyhIcon from "../assets/v2/yh/ChinaMinshengBank.png";
import gpzxyhIcon from "../assets/v2/yh/CITIC.png";
import gpgfyhIcon from "../assets/v2/yh/Guangfabank.png";
import gpnjyhIcon from "../assets/v2/yh/BankofNanjing.png";

// 各银行年度账单操作指引（步骤 + 截图）
import { gsyh } from "./gsyh/gsyh";
import { nyyh } from "./nyyh/nyyh";
import { xyyh } from "./xyyh/xyyh";
import { gdyh } from "./gdyh/gdyh";
import { shyh } from "./shyh/shyh";
import { jtyh } from "./jtyh/jtyh";
import { zsyh } from "./zsyh/zsyh";
import { yzyh } from "./yzyh/yzyh";
import { gfpayh } from "./gfpayh/gfpayh";
import { gpzgyh } from "./gpzgyh/gpzgyh";
import { gpjsyh } from "./gpjsyh/gpjsyh";
import { gpmsyh } from "./gpmsyh/gpmsyh";
import { gpzxyh } from "./gpzxyh/gpzxyh";
import { gpgfyh } from "./gpgfyh/gpgfyh";
import { gpnjyh } from "./gpnjyh/gpnjyh";

// 银行选择列表（与上方 icon、key 一一对应）
export const bankList = [
  {
    category: "常用银行",
    banks: [
      { name: "工商银行", color: "#c31e26", icon: gsyhIcon, key: "gsyh" },
      { name: "农业银行", color: "#008c4f", icon: nyyhIcon, key: "nyyh" },
      { name: "兴业银行", color: "#004a97", icon: xyyhIcon, key: "xyyh" },
      { name: "光大银行", color: "#6f2fa0", icon: gdyhIcon, key: "gdyh" },
      { name: "上海浦发", color: "#003893", icon: shyhIcon, key: "shyh" },
      { name: "交通银行", color: "#003366", icon: jtyhIcon, key: "jtyh" },
      { name: "招商银行", color: "#e60012", icon: zsyhIcon, key: "zsyh" },
      { name: "中国邮政", color: "#007a33", icon: yzyhIcon, key: "yzyh" },
    ],
  },
  {
    category: "股份制商业银行",
    banks: [
      { name: "平安银行", color: "#ff6a00", icon: gfpayhIcon, key: "gfpayh" },
      { name: "中国银行", color: "#c31e26", icon: gpzgyhIcon, key: "gpzgyh" },
      { name: "建设银行", color: "#003893", icon: gpjsyhIcon, key: "gpjsyh" },
      { name: "民生银行", color: "#0066b3", icon: gpmsyhIcon, key: "gpmsyh" },
      { name: "中信银行", color: "#c31e26", icon: gpzxyhIcon, key: "gpzxyh" },
      { name: "广发银行", color: "#e60012", icon: gpgfyhIcon, key: "gpgfyh" },
      { name: "南京银行", color: "#003893", icon: gpnjyhIcon, key: "gpnjyh" },
    ],
  },
];

// 各银行年度账单操作指引数据（key 与 bankList 中 key 对应）
export const yhCenter = {
  gsyh,
  nyyh,
  xyyh,
  gdyh,
  shyh,
  jtyh,
  zsyh,
  yzyh,
  gfpayh,
  gpzgyh,
  gpjsyh,
  gpmsyh,
  gpzxyh,
  gpgfyh,
  gpnjyh,
};
